module.exports = __webpack_public_path__ + "static/media/close.c6013b56.svg";